"use client";

import React, { FunctionComponent } from "react";
import Image from "next/image";
import Link from "next/link";
import { AssetDetails } from "contentful";

import { IBlog, IBlogFields } from "@/types/generated/contentful";
import { Button } from "@/components/button";
import { friendlyDate } from "@/helpers/dateTime";

type Props = {
  content: IBlog;
  leadingTile?: boolean;
};

export const BlogPostTile: FunctionComponent<Props> = ({
  content,
  leadingTile = false,
}) => {
  const { date, image, title, summary, slug, tags } =
    content.fields as IBlogFields;
  return (
    <Link
      href={`/insights/${slug}`}
      className={`group flex grow flex-col rounded-lg border border-gray-300`}
    >
      <Image
        src={`https:${image.fields.file?.url}`}
        alt={image.fields.description as string}
        width={(image.fields.file?.details as AssetDetails).image?.width}
        height={(image.fields.file?.details as AssetDetails).image?.height}
        className={`w-full rounded-t-lg ${leadingTile ? "" : "h-48"}`}
        style={{
          objectFit: "cover",
        }}
      />
      <div className="flex flex-1 flex-col gap-4 rounded-b-lg bg-gray-50 p-4 lg:gap-5 lg:p-5">
        <span className="felx text-sm md:hidden lg:flex">
          {friendlyDate(date)}
        </span>
        <span
          className={`flex font-medium ${leadingTile ? "text-2xl xl:text-4xl" : "text-base lg:text-xl"}`}
        >
          {title}
        </span>
        {leadingTile && (
          <span className="line-clamp-5 text-base font-light">{summary}</span>
        )}
        <div className="flex w-full flex-1 items-end text-cyan-700 lg:w-40">
          <Button
            style="secondary"
            label="Read more"
            appendClass="hover:text-primary"
          />
        </div>
      </div>
    </Link>
  );
};
